
import viapp from '../asset/porto/viapp.png'
import landx from '../asset/porto/landx.png'
import tfd from '../asset/porto/t_flawless_day.png'
import kasa from '../asset/porto/kasa.svg'
import twoK from '../asset/porto/2K_2018_Logo.svg.png'
import devias from '../asset/porto/devias-logo-1.png'

export const portfolioList = [
    {
        title: '2K Games Admin Portal',
        brief: 'An Admin portal to manage users and games data. Working with ReactJs and NodeJs',
        techStack: ['ReactJs', 'NodeJs', 'SCSS', 'HTML', 'AntDesign'],
        jobdesk: ['Join group discussing and expressing ideas to the team.', 'Complete user story', 'Doing RCA', 'Assess and estimate task.', 'Code reviews'],
        startDate: 'January 2023',
        endDate: 'March 2024',
        links: [{
            title: '2K Games',
            href: 'https://www.2k.com/en-US/'
        }],
        image: twoK
    }, {
        title: 'The Movie Database',
        brief: 'A web application to get a movie details, where you can see top rated movies, popular movies, and you even can like and leave some comment (note) in this app.',
        techStack: ['React', 'Tailwind CSS', 'HTML'],
        jobdesk: [],
        startDate: 'May 2022',
        endDate: 'May 2022',
        links: [{
            title: 'Go to The Movie Database Site',
            href: 'https://movie-database-by-yolanda.vercel.app'
        }],
        image: tfd
    }, {
        title: 'Murahati Web App',
        brief: 'An Application for Murahati (Gold Store) to record their transaction, managing products and also employees.',
        techStack: ['ReactJs', 'NextJs', 'Firebase', 'MUI', 'SCSS', 'HTML'],
        jobdesk: [],
        startDate: 'Feb 2023',
        endDate: 'August 2023',
        links: [{
            title: 'Murahati Site',
            href: 'https://www.murahati.online/'
        }],
        image: devias
    }, {
        title: 'Landx Web App',
        brief: 'This is my company project at Landx.id. A Platform for users to invest in equity crowdfunding.',
        techStack: ['ReactJs', 'VanillaJs', 'Tailwind CSS', 'SCSS', 'HTML'],
        jobdesk: ['Translating UI/UX design into working code', 'Bugfixing', 'Reviewing Code'],
        startDate: 'December 2021',
        endDate: 'December 2022',
        links: [{
            title: 'Go to Landing Page',
            href: 'https://icx.id'
        }],
        image: landx
    }, {
        title: 'The Flawless Day',
        brief: 'A web platform to make online wedding invitation. User can make their own wedding invitation within just a few minutes. Equipped with automatic payments',
        techStack: ['React', 'Firebase', 'MUI', 'SCSS', 'HTML'],
        jobdesk: [],
        startDate: 'March 2022',
        endDate: 'Present (In Maintenance State)',
        links: [{
            title: 'Go to The Flawless Day',
            href: 'https://the-flawless-day-54909.web.app'
        }],
        image: tfd
    }, {
        title: 'Kasa Landing Page',
        brief: 'My freelance project for Kasa Creative, which is a brand for Branding and Marketing solution.',
        techStack: ['React', 'Tailwind CSS', 'HTML'],
        jobdesk: [],
        startDate: 'March 2022',
        endDate: 'March 2022',
        links: [],
        image: kasa
    }, {
        title: 'VI App',
        brief: 'This is my company project at 8I Holdings Limited. Where users can track their investment progress, interact with other users (social function), and many other cool features.',
        jobdesk: ['Translating UI/UX design into working code', 'Bugfixing'],
        techStack: ['Angular', 'Angular Material', 'SCSS', 'HTML'],
        startDate: 'November 2019',
        endDate: 'November 2021 (2 Years Exp)',
        links: [{
            title: '',
            href: 'https://goodwhale.com/'
        }],
        image: viapp
    }]